import { render, staticRenderFns } from "./BulkOperationDocunents.vue?vue&type=template&id=5233dbfa&scoped=true&"
import script from "./BulkOperationDocunents.vue?vue&type=script&lang=js&"
export * from "./BulkOperationDocunents.vue?vue&type=script&lang=js&"
import style0 from "./BulkOperationDocunents.vue?vue&type=style&index=0&id=5233dbfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233dbfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemContent,VListItemTitle,VMenu})
